import { setFinalBwv, setFinalNeeds } from "../../../redux/slices/BwvData";
import axios from "axios"; // You'll need axios or another HTTP client

export const applyFilters = async (
  dispatch,
  originalBwv,
  originalNeeds,
  selectedCat,
  selectedSubCat,
  selectedItem,
  searchTerm,
  bwvSearchQuery,
  priceRange,
  radius,
  selectedOption,
  selectedOptionData
) => {
  let products = [...originalBwv];
  let needs = [...originalNeeds];
  console.log(products, "products");

  const getMinPackagePrice = (packageData) => {
    const packages = packageData === null ? [] : Object.values(packageData);
    const prices = packages.map((userpackage) =>
      parseFloat(userpackage.totalPrice)
    );
    return Math.min(...prices);
  };

  // Function to fetch nearby zip codes using ZipcodeAPI
  const fetchNearbyLocations = async (location, radius) => {
    const apiKey = process.env.REACT_APP_ZIPCODEBASE_KEY; // Replace with your actual API key
    const [city, state] = location.split(", ").map((part) => part.trim());
    const baseUrl = "https://app.zipcodebase.com/api/v1/radius";
    try {
      // First, geocode the city to get a zip code
      const geocodeUrl = `https://app.zipcodebase.com/api/v1/search?codes=${city}&country=us&apikey=${apiKey}`;
      const geocodeResponse = await axios.get(geocodeUrl);
      const zipCode = geocodeResponse.data.results[city][0].code;
      console.log(zipCode, "zipCode");
      // Fetch nearby zip codes within the radius
      const radiusUrl = `${baseUrl}?code=${zipCode}&radius=${radius}&country=us&apikey=${apiKey}`;
      const response = await axios.get(radiusUrl);
      const nearbyZips = response.data.results.map((result) => result.code);
      return nearbyZips;
    } catch (error) {
      console.error("Error fetching nearby locations:", error);
      return [];
    }
  };

  // Category filter
  if (selectedCat) {
    products = products.filter(
      (product) => selectedCat.Id === product.categoryId
    );
    needs = needs.filter((need) => selectedCat.Id === need.categoryId);
    console.log(products, "products-selectedCat");
  }

  // Subcategory filter
  if (selectedSubCat) {
    products = products.filter(
      (product) => selectedSubCat.Id === product.subCategoryId
    );
    needs = needs.filter((need) => selectedSubCat.Id === need.subCategoryId);
    console.log(products, "products-selectedSubCat");
  }

  // Item filter
  if (selectedItem) {
    products = products.filter((product) => {
      const subCatItemName =
        selectedItem.subCatItemName?.trim().toLowerCase() || "";
      const itemName = product.itemName?.trim().toLowerCase() || "";
      const subCategoryName =
        product.subCategoryName?.trim().toLowerCase() || "";
      const categoryName = product.categoryName?.trim().toLowerCase() || "";
      return (
        subCatItemName === itemName ||
        subCatItemName === subCategoryName ||
        subCatItemName === categoryName
      );
    });
    needs = needs.filter((need) => {
      const subCatItemName =
        selectedItem.subCatItemName?.trim().toLowerCase() || "";
      const itemName = need.itemName?.trim().toLowerCase() || "";
      const subCategoryName = need.subCategoryName?.trim().toLowerCase() || "";
      const categoryName = need.categoryName?.trim().toLowerCase() || "";
      return (
        subCatItemName === itemName ||
        subCatItemName === subCategoryName ||
        subCatItemName === categoryName
      );
    });
    console.log(products, "products-selectedItem");
  }

  // Search term and radius filter
  if (searchTerm && radius) {
    console.log(radius, "radius");
    const nearbyZips = await fetchNearbyLocations(searchTerm, radius);
    products = products.filter((product) => {
      const productLocation = product.Location?.trim().toLowerCase() || "";
      // Check if the product's location contains any of the nearby zip codes or the search term
      return (
        nearbyZips.some((zip) => productLocation.includes(zip)) ||
        productLocation.includes(searchTerm.toLowerCase())
      );
    });
    console.log(products, "products-radius-and-searchTerm");
  } else if (searchTerm) {
    // Fallback to simple search term filter if no radius
    products = products.filter(
      (product) =>
        product.Location &&
        product.Location.toLowerCase().includes(searchTerm.toLowerCase())
    );
    console.log(products, "products-searchTerm");
  }

  // BWV search query filter
  if (bwvSearchQuery) {
    const trimmedQuery = bwvSearchQuery.trim().toLowerCase();
    products = products.filter((product) => {
      const listNameMatch = product.listName
        ?.trim()
        .toLowerCase()
        .includes(trimmedQuery);
      const subCategoryMatch = product.subCategoryName
        ?.trim()
        .toLowerCase()
        .includes(trimmedQuery);
      const catMatch = product.categoryName
        ?.trim()
        .toLowerCase()
        .includes(trimmedQuery);
      const itemMatch = product.itemName
        ?.trim()
        .toLowerCase()
        .includes(trimmedQuery);
      const location = product.Location?.trim()
        .toLowerCase()
        .includes(trimmedQuery);
      const decMatch = product.Description?.trim()
        .toLowerCase()
        .includes(trimmedQuery);
      return (
        listNameMatch ||
        subCategoryMatch ||
        catMatch ||
        itemMatch ||
        location ||
        decMatch
      );
    });
    needs = needs.filter((need) => {
      const title = need.Title?.trim().toLowerCase().includes(trimmedQuery);
      const subCategoryMatch = need.subCategoryName
        ?.trim()
        .toLowerCase()
        .includes(trimmedQuery);
      const catMatch = need.categoryName
        ?.trim()
        .toLowerCase()
        .includes(trimmedQuery);
      const itemMatch = need.itemName
        ?.trim()
        .toLowerCase()
        .includes(trimmedQuery);
      const decMatch = need.Description?.trim()
        .toLowerCase()
        .includes(trimmedQuery);
      return title || subCategoryMatch || catMatch || itemMatch || decMatch;
    });
    console.log(products, "products-bwvSearchQuery");
  }

  // Price range filter
  if (priceRange && priceRange.length === 2) {
    console.log(priceRange, "priceRange");
    const [minRange, maxRange] = priceRange;
    products = products.filter((product) => {
      const minPackagePrice =
        // getMinPackagePrice(JSON.parse(product.Package)) ||
        getMinPackagePrice(JSON.parse(product.dealPackage));
      const price = Number(product.hourlyPrice) || minPackagePrice;
      return (price >= minRange && price <= maxRange) || price === Infinity;
    });
    console.log(products, "products-priceRange");
  }

  // Selected option filter
  if (selectedOption) {
    products = products.filter((product) =>
      product.customDetails.hasOwnProperty(selectedOption.list_name)
    );
    console.log(products, "products-selectedOption");
  }

  // Selected option data filter
  if (selectedOptionData) {
    const selectedOptionName = selectedOptionData.option_name;
    products = products.filter((product) => {
      return Object.values(product.customDetails).some((optionsArray) =>
        optionsArray.some((option) => option.option_name === selectedOptionName)
      );
    });
    console.log(products, "products-selectedOptionData");
  }

  console.log(products, "products");
  // Dispatch filtered results
  dispatch(setFinalBwv(products));
  dispatch(setFinalNeeds(needs));

  return { products, needs };
};
